import { render, staticRenderFns } from "./EditPersonalInfoPopup.vue?vue&type=template&id=3df72247&scoped=true&"
import script from "./EditPersonalInfoPopup.vue?vue&type=script&lang=js&"
export * from "./EditPersonalInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonalInfoPopup.vue?vue&type=style&index=0&id=3df72247&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df72247",
  null
  
)

export default component.exports